import React from 'react';
import SbEditable from 'storyblok-react';

const PressNewsMention = (props) => {
  return (
    <SbEditable content={props.blok}>
      <div className="press-news-mention">
        <h4>
          <a href={props.blok.link_url} target="_blank" rel="noreferrer">
            {props.blok.title}
          </a>
        </h4>
        <h5>{props.blok.publisher}</h5>
      </div>
    </SbEditable>
  );
};

export default PressNewsMention;
